<template>
    <div class="leftBox ">
        <div class="cockpitBox">
            <div class="cockpit_header">
                <div class="cockpit_header_bg">
                    <div><img :src="require('@/assets/img/cockpit/deng.png')" alt=""></div>
                    <div class="header_title">项目预警</div>
                    <div><img :src="require('@/assets/img/cockpit/dian.png')" alt=""></div>
                </div>
            </div>
            <div class="cockpit_content warning_box1">
                <div class="left_left_box">
                    <div id="echartsData"></div>
                    <div class="rightFrequency">
                        <div class="rightFrequency_box" v-for="(item,index) in trafficWay" :key="index">
                            <div :style="{'background':colorList[index]}"></div>
                            <div>{{item.name}}</div>
                            <div>{{total>0?(((item.value/total)*100).toFixed(2))+'%':0+'%'}}</div>
                        </div>
                    </div>
                </div>
                <div class="left_right_box">
                    <div class="warn_detail_box" v-for="(item,index) in warnData " :key="index">
                        <div class="warn_detail_box_top">
                            <img :src="require('@/assets/img/cockpit/warn/left_left.png')" alt="">
                            <div class="detail_middle">
                                <div class="detail_middle_top">
                                    <div><span>{{item.rate}}</span> %</div>
                                    <span></span>
                                    <div><span>{{item.count}}</span> 条</div>
                                </div>
                                <img :src="require(`@/assets/img/cockpit/warn/left${index+1}.png`)" alt="">
                            </div>
                            <img :src="require('@/assets/img/cockpit/warn/left_right.png')" alt="">
                        </div>
                        <div class="warn_detail_box_title">{{item.name}} </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cockpitBox" style="margin-top:16px">
            <div class="cockpit_header">
                <div class="cockpit_header_bg">
                    <div><img :src="require('@/assets/img/cockpit/deng.png')" alt=""></div>
                    <div class="header_title">项目预警信息</div>
                    <div><img :src="require('@/assets/img/cockpit/dian.png')" alt=""></div>
                </div>
            </div>
            <div class="cockpit_content warning_box2">
                <div class="warn-color">
                    <div class="warn-flex">
                        <div class="flex-left">
                            <span v-for="(item,index) in count" :key="index">
                                <b>{{item.count}}</b>条 {{item.gradeName}}
                            </span>
                        </div>
                        <div class="flex-right">
                            <span><b>{{countTotal}}</b></span>
                        </div>
                    </div>
                    <div class="color-list">
                        <div class="color">
                            <span v-for="(item,index) in count" :key="index" :style="{width:((item.count)/countTotal*100)+'%',background:dealColorFn(item.gradeType).color}"></span>
                        </div>
                        <span style="color:rgba(255, 255, 255, 0.65);">待处理数</span>
                    </div>
                </div>
                <div class="warn_content">
                    <div v-for="(items,indexs) in cardData" :key="indexs">
                        <div class="header_box">
                            <div>
                                <img :src="dealColorFn(items.type).imgUrl" align="bottom" alt="">
                                <span :style="{color:(dealColorFn(items.type).color)}">{{dealColorFn(items.type).name}}</span>
                            </div>
                        </div>
                        <div class="content-box">
                            <div style="display:flex;flex-wrap:wrap">
                                <div class="complaints_list" v-for="(item,index) in items.list" :key="index">   
                                    <template v-if="item.menuItemCode!='JGW-1-4'">
                                        <cardList1 :item="item" :warnOptions="warnGradeList" @refreshData="searchData" :historyid="item.historyid" :type="dealColorFn(items.type)"></cardList1>
                                    </template>
                                    <template v-else>
                                        <cardList2 :item="item" :warnOptions="warnGradeList" @refreshData="searchData" :historyid="item.historyid" :type="dealColorFn(items.type)"></cardList2>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="more_box" @click="jumpMore">
                    <img :src="require('@/assets/img/cockpit/warn/more.png')" alt="">
                    查看更多</div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts/core";
import { BarChart,ScatterChart,PieChart,PictorialBarChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  DatasetComponentOption,
  TransformComponent,
  LegendComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  PictorialBarChart,
  ScatterChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent
]);
import {jzwarnrecordList,listWarnGrade,countWarnGrade,listWarnRecord} from '@/server/warnItem'
import cardList1 from './cardList1.vue';
import cardList2 from './cardList2.vue';
import {findMenuItem} from '@/utils/index'
export default {
    data(){
        return{
            warnGradeList:[],
            cardData:[],
            count:[],
            countTotal:'',
            trafficWay:[
                {
                    name: '已处理',
                    value: 20,
                },
                {
                    name: '未处理',
                    value: 40,
                },
                {
                    name: '已忽略',
                    value: 40,
                },
            ],
            colorList:['#FACC14','#65CC57',  '#BFDBF8'],
            total:0,
            warnData:[]
        }
    },
    components:{
        cardList1,
        cardList2
    },
    mounted(){
        this.getDic()
    },
    methods:{
        dealColorFn(type){//处理数据
            var data=this.warnGradeList.filter((ele)=>{return ele.type==type})
            return data[0];
        },
        getDic(){//获取预警类型
            listWarnGrade().then((res) => {
                if(res.data.code==1){
                    this.warnGradeList=(res.data.data).reverse();
                    this.cardData=[];
                    for(var j in this.warnGradeList){
                        this.cardData.push({type:this.warnGradeList[j].type,list:[],page:{}})
                    }
                    for(var i in  this.warnGradeList){
                        this.getCardData(this.warnGradeList[i].type,0,2);
                    }
                    
                }else{
                    this.$message.error(res.data.msg)
                }
            })
            countWarnGrade('').then((res) => {
                this.countTotal=0;
                if(res.data.code==1){
                    this.count=(res.data.data).reverse();
                    for(var i in this.count){
                        this.countTotal+=parseInt(this.count[i].count);
                    }
                }else{
                    this.$message.error(res.data.msg)
                }
            })

            this.$httpReq({//获取待受理投诉数据
                url: '/homePage/getWarnCount',
                method: 'get'
            }).then(({data}) => {
                if(data.code==1){
                    this.trafficWay=[]
                    for(var i in data.data.warnCount){
                        this.trafficWay.push({name:data.data.warnCount[i].historyidName,value:data.data.warnCount[i].count})
                    }
                    
                    this.getBarData();
                }
            })

            this.$httpReq({//获取待受理投诉数据
                url: '/jzwarnrecord/countWarnType?itemCode=JGW-1',
                method: 'get'
            }).then(({data}) => {
                if(data.code==1){
                    this.warnData=data.data;
                }
            })

            
        },
        getCardData(type,start,rows){//获取卡片数据
            listWarnRecord({
                filter:{
                    gradeType:type,
                    itemCode:'',
                    pageIndex:start,
                    pageSize:rows,
                    dataType:1,
                },
            }).then((res) => {
                for(var i in this.cardData){
                    if(this.cardData[i].type==type){
                        this.$set(this.cardData[i],'list',res.data.rows)
                        this.$set(this.cardData[i],'page',{start:start,total:res.data.total})
                    }
                }
            })
        },
        jumpMore(){//查看更多
            window.open(  '/early_warning/list');
            // window.opener.postMessage({type:true,url:'early_warning_list',parent:'early_warning_list',query:{}}, '*')
            // window.close()
        },
        getBarData(){
            var trafficWay=this.trafficWay
            var data = [],total=0;
            var color = this.colorList;
            for (var i = 0; i < trafficWay.length; i++) {
                total+=trafficWay[i].value
            }
            this.total=total;
            for (var i = 0; i < trafficWay.length; i++) {
                data.push(
                    {
                        value: trafficWay[i].value,
                        name: trafficWay[i].name,
                    },
                    // {
                    //     value: total*0.005,
                    //     name: '',
                    //     itemStyle: {
                    //         normal: {
                    //             color: 'rgba(0, 0, 0, 0)',
                    //             borderColor: 'rgba(0, 0, 0, 0)',
                    //             borderWidth: 0,
                    //         },
                    //     },
                    // }
                );
            }
            var option = {
                color: color,
                series: [
                {
                    type: 'pie',
                    clockWise: false,
                    radius: ['78%', '92%'],
                    center:['45%','center'],
                    itemStyle: {
                        normal: {
                            borderColor: '#17355a',
                            borderWidth: 3,
                            labelLine: {
                                show: false,
                            },
                        },
                    },
                    label:{
                        position: 'center',
                        show:false,
                        formatter: (params) => {
                            return `{a|${params.data.name}}\n{b|${params.data.value}} {c|宗}`
                        },
                        rich:{
                            a:{
                                fontSize:16,
                                padding:[0,0,10,0],
                                color:'#fff',
                            },
                            b:{
                                fontSize:20,
                                color:'#fff',
                            },
                            c:{
                                fontSize:12,
                                color:'#9FC4E4'
                            }
                        }
                    },
                    emphasis: {
                        label: {
                            show:true
                        }
                    },
                    data: data,
                },
                {
                    type: 'pie',
                    color: '#C0DCF9',
                    clockWise: false,
                    center:['45%','center'],
                    radius: ['65%', '66%'],
                    hoverAnimation: false,
                    itemStyle: {
                        normal: {
                            label: { show: false },
                            shadowBlur:10,
                            shadowColor:'#C0DCF9'
                        },
                    },
                    data: [100],
                },
            ]
            };
            var myChart=document.getElementById("echartsData");
            let chartBox = echarts.init(myChart);
            chartBox.setOption(option)
            setTimeout(function() {
                chartBox.on('mouseover', function(params) {
                    if (params.name == data[0].name) {
                        chartBox.dispatchAction({
                            type: 'highlight',
                            seriesIndex: 0,
                            dataIndex: 0
                        });
                    } else {
                        chartBox.dispatchAction({
                            type: 'downplay',
                            seriesIndex: 0,
                            dataIndex: 0
                        });
                    }
                });

                chartBox.on('mouseout', function(params) {
                    chartBox.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 0,
                        dataIndex: 0
                    });
                });
                chartBox.dispatchAction({
                    type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: 0
                }); 
            }, 1000);
            window.addEventListener('resize', () => {
                chartBox.resize()
            })

        },
        searchData(){
            listWarnGrade().then((res) => {
                if(res.data.code==1){
                    this.warnGradeList=(res.data.data).reverse();
                    this.cardData=[];
                    for(var j in this.warnGradeList){
                        this.cardData.push({type:this.warnGradeList[j].type,list:[],page:{}})
                    }
                    for(var i in  this.warnGradeList){
                        this.getCardData(this.warnGradeList[i].type,0,2);
                    }
                    
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .leftBox{
        .warning_box1{
            height: 202px;
            overflow: hidden;
            display: flex;
            align-items: center;
        }
        .warning_box2{
            height: 628px;
             .warn-color{
                height: 96px;
                margin: 28px 16px 16px;
                background: rgba(24, 144, 255, 0.25);
                border-radius: 4px 4px 4px 4px;
                color: rgba(0, 0, 0, 0.45);
                padding: 0px 26px 0px 16px;
                .warn-flex{
                    display: flex;
                    justify-content: space-between;
                    align-items:center;
                    padding: 28px 0px 14px 0px;
                    b{
                        font-size: 18px;
                        color:rgba(255, 255, 255, 0.65);
                    }
                    span{
                        padding-right:23px
                    }
                    .flex-left{
                        color: #9FC4E4;
                        b{
                            font-weight: bold;
                            color: #FFFFFF;
                            margin-right: 3px;
                        }
                    }
                }
                .color-list{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .color{
                        width: 93%; 
                        height: 16px;
                        // border-left: 500px solid #F23030; 
                        // // background: #F23030;
                        // border-right: 500px solid #FF9900;
                        // background: #eff3f6;
                        margin-right: 16px;
                        
                        span{
                            display: inline-block;
                            height: 100%;
                            &:nth-of-type(1){
                                border-radius: 4px 0px 0px 4px;
                            }
                            &:last-child{
                                border-radius: 0px 4px 4px 0px;
                            }
                        }
                    }
                }
            }
        }
        .warn_content{
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            &>div{
                width: calc(33% - 12px);
                flex-shrink: 0;
                flex-grow: 0;
                &:nth-of-type(2){
                    margin: 0 24px;
                }
            }
            .complaints_list{
                width: 100%;
                margin-top: 10px;
                margin-bottom: 14px;
            }
        }
        .more_box{
            color: #5CEDFF;
            text-align: center;
            cursor: pointer;
        }
        .left_left_box{
            width: 29%;
            height: 154px;
            display: flex;
            justify-content: space-between;
            #echartsData{
                width: 58%;
                height: 154px;
            }
            border-right: 1px solid;
            border-image: linear-gradient(147deg, rgba(169, 226, 247, 0), rgba(166, 231, 255, 1), rgba(169, 226, 247, 0)) 1 1;
            
        }
        .left_right_box{
            margin: 0 24px;
            width: 71%;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .warn_detail_box{
            width: calc((100% - 96px)/5);
            height: 108px;
            text-align: center;
            .warn_detail_box_top{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .detail_middle{
                    color: rgba(255, 255, 255, 0.85);
                    flex: 1;
                    .detail_middle_top{
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &>span{
                            width: 1px;
                            height: 16px;
                            background: #FFFFFF;
                            border-radius: 0px 0px 0px 0px;
                            opacity: 0.3;
                            display: inline-block;
                            margin: 0 8px;
                        }
                        &>div:nth-of-type(2){
                            text-align: right;
                        }
                        &>div>span{
                           font-size: 20px; 
                           color: #FFFFFF;
                           text-shadow: 0px 0px 6px rgba(24, 144, 255, 0.8);
                        }
                        &>div:nth-of-type(2){
                            text-align: left;
                            color: #5CEDFF;
                            span{
                                color: #5CEDFF;
                            }
                        }
                    }
                }
            }
            .warn_detail_box_title{
                color: rgba(255, 255, 255, 0.85);
            }
        }
        .rightFrequency{
            width: calc(42% - 24px);
            margin-right: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .rightFrequency_box{
                display: flex;
                align-items: center;
                margin-bottom: 16px;
                height: 28px;
                background-color: rgba(24, 144, 255, 0.1);
                font-size: 12px;
                &>div{
                    &:nth-of-type(1){
                        width: 9px;
                        height: 9px;
                        margin-left: 8px;
                    }
                    &:nth-of-type(2){
                        font-size: 12px;
                        margin: 0 16px 0 8px;
                        color: #9FC4E4;
                    }
                    &:nth-of-type(3){
                        margin-right: 5px;
                        color: #9FC4E4;
                    }
                }
                
            }
        }
    }
</style>